import React from "react";
import T from "prop-types";
import { shortDate } from "LIB/formatters/date";
import { DetailTable, Detail } from "MODULES/shared/components/DetailTable";
import Section from "MODULES/shared/components/Section";
import { renderIf } from "MODULES/shared/decorators";
import { CUSTOMER_RMA_TYPE } from "MODULES/RMAsAndWarranties/constants";
import pojo from "LIB/pojos";
import Form from "./Form";

export function CustomerRMASection({ rma }) {
  const receivedVirt =
    (rma.received_virtually === false && "No") ||
    (rma.received_virtually && "Yes") ||
    null;

  return (
    <React.Fragment>
      <hr className="hr-xs hr-dashed" />
      <Section
        title="Customer RMA"
        modal={{
          title: "Edit Customer RMA Details",
          dialogClass: "modal-sm",
          content: close => (
            <Form
              initialValues={pojo(rma).pick("incoming_awb_number")}
              close={close}
            />
          )
        }}
      >
        <DetailTable>
          <Detail label="Date In" value={shortDate(rma.date_in)} />
          <Detail label="Incoming AWB #" value={rma.incoming_awb_number} />
          <Detail label="Received Virtually" value={receivedVirt} />
          <Detail label="Returning AWB #" value={rma.outgoing_awb_number} />
        </DetailTable>
      </Section>
    </React.Fragment>
  );
}

CustomerRMASection.propTypes = {
  rma: T.shape({
    date_in: T.string,
    incoming_awb_number: T.string
  }).isRequired
};

export default renderIf(({ rma }) => rma.type === CUSTOMER_RMA_TYPE)(
  CustomerRMASection
);



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/CustomerRMASection/CustomerRMASection.jsx